import {
  AttendanceRegisterSessionGroupIds,
  EligibleRegisterAgeGroupEntry,
  EligibleRegisterGroup,
  EligibleRegisterSessionEnum,
  RegisterAgeGroupEntry,
} from '@schooly/api';

export type RegisterSession = EligibleRegisterSessionEnum;

export const REGISTER_SESSIONS: RegisterSession[] = [
  EligibleRegisterSessionEnum.Am,
  EligibleRegisterSessionEnum.Pm,
];

export const toRegisterSession = (session?: string | null): RegisterSession | null =>
  session === EligibleRegisterSessionEnum.Am || session === EligibleRegisterSessionEnum.Pm
    ? session
    : null;

export const REGISTER_PERIOD_TAB = 'per-period' as const;

export type RegisterTab = RegisterSession | typeof REGISTER_PERIOD_TAB;

export const isSessionTab = (tab: RegisterTab): tab is RegisterSession =>
  tab === EligibleRegisterSessionEnum.Am || tab === EligibleRegisterSessionEnum.Pm;

export type RegisterScope = { session: RegisterSession } | { periodId: string };

export type RegisterSessionScope = { session: RegisterSession };

export const isSessionScope = (scope: RegisterScope): scope is RegisterSessionScope =>
  'session' in scope;

export type RegisterGroupTarget =
  | { session: RegisterSession; periodId?: string }
  | { session?: RegisterSession; periodId: string };

export type RegisterPeriodGroupIds = Record<string, string[]>;

export type RegisterGroupIds = AttendanceRegisterSessionGroupIds & {
  periods: RegisterPeriodGroupIds;
};

export type AgeGroupEntry = EligibleRegisterAgeGroupEntry | RegisterAgeGroupEntry;

type CompositionSnapshot = {
  sessions: RegisterSession[];
  period_ids: string[];
  age_group_entries: RegisterAgeGroupEntry[];
};

export type RosterGroup = EligibleRegisterGroup & {
  snapshot?: CompositionSnapshot;
};

export type RegisterPeriodStructure = { id: string; name: string };

export type RegisterPeriod = {
  id: string;
  name: string;
  start_time: string;
  end_time: string;
  register_session: RegisterSession | null;
  structure: RegisterPeriodStructure;
  order: number;
};

export type RegisterStructuresWithPeriods = {
  structures: RegisterPeriodStructure[];
  periodsByStructureId: Record<string, RegisterPeriod[]>;
};
